<template>
	<div>
		<template v-if="network_success">
			<!-- banner -->
			<banner></banner>
			<!-- banner end -->
			
			<!-- 科飞课堂 -->
			<kf-course :list="course_list" @onClick="handleCourseClick"></kf-course>
			<!-- 科飞课堂 end -->
			
			<!-- 弱视百科 -->
			<ae></ae>
			<!-- 弱视百科 end -->
			
			<!-- 新闻动态 -->
			<news></news>
			<!-- 新闻动态 end -->
			
			<!-- 视频弹出框 -->
			<screen-video v-model="course_play" :src="course_src"></screen-video>
			<!-- 视频弹出框 end -->
		</template>
		
		<!-- 网络出错 -->
		<network-err v-if="!network_success" @onRefresh="handleNetworkRefresh"></network-err>
		<!-- 网络出错 end -->
	</div>
</template>

<script>
	import Banner from './components/banner.vue';
	import KfCourse from './components/kf_course.vue';
	import Ae from './components/ae.vue';
	import News from './components/news.vue';
	import { mapMutations } from 'vuex';
	import Api from '../../../api/api.js';
	
	export default {
		mounted() {
			this.getCourseData();
		},
		data() {
			return {
				network_success: true,
				course_list: [],
				course_src: '',
				course_play: false
			}
		},
		methods: {
			/*************** @Events *******************/
			// 点击科飞课堂
			handleCourseClick(courseId) {
				this.getCourseDetail(courseId);
			},
			// 网络错误刷新
			handleNetworkRefresh() {
				this.getCourseData();
			},
			
			/*************** @Function *******************/
			// 获取科飞课堂视频
			getCourseData() {
				const that = this;
				that.setLoading(true);
				let requestData = {
					firstId: 21,
					twoId: 41,
					pageNum: 1,
					limit: 12
				};
				Api.findCourseList(requestData).then((res) => {
					if (res.data.success) {
						that.setLoading(false);
						that.network_success = true;
						res.data.data.data.forEach((v, i) => {
							i <= 5 && (that.course_list.push(v));
						});
					} else {
						that.setLoading(false);
						that.network_success = false;
					}
				}, () => {
					that.setLoading(false);
					that.network_success = false;
				});
			},
			// 获取小器械视频详情
			getCourseDetail(courseId) {
				const that = this;
				that.setLoading(true);
				let requestData = {
					courseId: courseId
				};
				Api.getCourseDetail(requestData).then((res) => {
					if (res.data.success) {
						that.setLoading(false);
						that.course_src = res.data.data.playUrl;
						that.course_play = true;
					} else {
						that.setLoading(false);
						that.swal(res.data.message, {button: false});
					}
				}, (e) => {
					that.setLoading(false);
					that.swal(e.message, {button: false});
				});
			},
			...mapMutations({
				"setLoading": "setLoading"
			})
		},
		components: {
			Banner,
			KfCourse,
			Ae,
			News
		}
	}
</script>

<style>
</style>
